import { forwardRef } from 'react';

import type { BoxProps } from '@hivebrite/design-system/Box';
import type { ModalElement } from '@hivebrite/design-system/Dialog';

import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import V1 from './V1';
import V2 from './V2';
import type { ModalWithTemplateProps } from '../types';

export default forwardRef<
  ModalElement,
  ModalWithTemplateProps & {
    bodyProps?: BoxProps;
    headProps?: BoxProps;
    footProps?: BoxProps;
    isOpen?: boolean;
    isSticky?: boolean;
    style?: React.CSSProperties;
  }
>(({ isOpen, ...props }, ref) => {
  const { flagMobileNewDialog } = useFeatureFlag();

  return flagMobileNewDialog && typeof isOpen === 'boolean' ? (
    <V2 {...props} isOpen={isOpen} ref={ref} />
  ) : (
    <V1 {...props} ref={ref} />
  );
});
